import ReactDOMClient from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { ToastContainer } from "react-toastify";
import Rollbar from "rollbar";

import { deepFreezeObject, booleanify, getAuthenticityToken } from "@utils";

import App from "~/app/frontend/javascripts/App.js";
import ErrorFallbackPage from "@pages/ErrorFallbackPage";

document.addEventListener("DOMContentLoaded", () => {
  window.appContext = deepFreezeObject(booleanify({
    ...document.body.dataset,
    authenticityToken: getAuthenticityToken(),
  }));

  if (window.appContext.env === "production" && window.appContext.rollbarClientToken) {
    window.rollbar = new Rollbar({
      accessToken: window.appContext.rollbarClientToken,
      captureUncaught: true,
      captureUnhandledRejections: true,
      environment: window.appContext.env,
      enabled: true,
    });
  }

  /**************************************************************************************************/

  sessionStorage.removeItem("_kinn_asset_reload");

  const versionReloadTarget = sessionStorage.getItem("_kinn_version_reload");

  if (versionReloadTarget && versionReloadTarget === window.KINN_APP_VERSION) {
    sessionStorage.removeItem("_kinn_version_reload");
  }

  /**************************************************************************************************/

  const consolePrintKinnMark = () => console.info(window.KINN_MARK);
  window.consolePrintKinnMark = consolePrintKinnMark;

  /**************************************************************************************************/

  const appElement = document.getElementById("app");
  if (appElement === null) throw new Error("Missing app element");

  const app = ReactDOMClient.createRoot(appElement);

  const props = JSON.parse(appElement.dataset.props);
  const component = appElement.dataset.component;

  app.render(
    <ErrorBoundary FallbackComponent={ErrorFallbackPage}>
      <App component={component} {...props} />
      <ToastContainer theme="dark" />
    </ErrorBoundary>
  );
});
